// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-28bb3f2e]{display:block;position:fixed;z-index:9999;overflow:auto;min-height:100%}", ""]);
// Exports
module.exports = exports;
